import React from 'react';
import styles from './drawerContent.module.scss';
import IconArrowLeft from '@/assets/icons/drawer-icons/icon-arrow-left.svg';
import IconClose from '@/assets/icons/icon-round-close.svg';
import Link from 'next/link';
import { CategoryEdge } from '@/apollo/graphql/types/categoryTypes';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import Skeleton from 'react-loading-skeleton';
import { useLocale } from 'next-intl';
import Image from 'next/image';
import { renderSkeletons } from '../skeleton';
import { config } from '@/apollo/config';
import IconArrowRight from '@/assets/icons/drawer-icons/icon-arrow-right.svg';
import { brandListType } from '@/types/headerBottomDriver.type';

const MobileVersionLinks = ({
  closeLinkButton,
  tabName,
  transformedData,
  tab,
  brandLoading,
  brandList,
}: {
  closeLinkButton: () => void;
  tabName: string;
  transformedData: any;
  tab: string;
  brandLoading: boolean;
  brandList: brandListType[];
}) => {
  const locale = useLocale();
  return (
    <div className={styles.mobileVersionLinks}>
      <div className={styles.mobileClose}>
        <h3 onClick={closeLinkButton}>
          <IconArrowLeft /> {tabName}
        </h3>
        <button
          type="button"
          className={styles.drawer__closeButton}
          onClick={closeLinkButton}
        >
          <IconClose />
        </button>
      </div>
      {transformedData.length === 0 ? (
        <div className={styles.drawer__rightSection}>
          <div
            className={styles.subCategoriesBrandsLinks}
            style={{ gap: '20px' }}
          >
            {Array.from({ length: 5 }).map((_, index) => (
              <div
                key={index}
                className={styles.subCategoriesBrandsSmartphones}
              >
                <h3 className={`${styles.skeletonForMobile}`}>
                  <Skeleton />
                </h3>
                {Array.from({ length: 3 }).map((_, index) => (
                  <Link
                    href={'#'}
                    key={index}
                    className={`${styles.skeletonForMobile}`}
                  >
                    <Skeleton />
                  </Link>
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : (
        transformedData.map((category: any) => {
          if (tab === category.id) {
            const Items = category.edges.filter(
              (edge: CategoryEdge) =>
                !edge.node.isPopular && edge.node.isInCatalog
            );
            return (
              <div className={styles.drawer__rightSection} key={category.id}>
                <div
                  className={styles.subCategoriesBrandsLinks}
                  style={{ gap: '20px' }}
                >
                  {Items.map((edge: CategoryEdge) => (
                    <div
                      key={edge.node.id}
                      className={styles.subCategoriesBrandsSmartphones}
                    >
                      <h3>
                        {locale === 'ru'
                          ? edge.node.name
                          : edge?.node?.translation?.name}
                      </h3>
                      {edge.node.children.edges.map((child: CategoryEdge) => (
                        <Link
                          href={`/category/${decodeBase64Id(child.node.id)}-${child.node.slug}`}
                          key={child.node.name}
                          onClick={closeLinkButton}
                        >
                          {locale === 'ru'
                            ? child.node.name
                            : child?.node?.translation?.name}{' '}
                          <IconArrowRight />
                        </Link>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            );
          }
          return null;
        })
      )}
      <div className={styles.subCategoriesBrands}>
        {brandLoading
          ? renderSkeletons(
              5,
              `${styles.subCategoriesBrandsBrand} ${styles.skeletonForMobile}`
            )
          : brandList?.map((brand: any, i: any) => (
              <div key={i} className={styles.subCategoriesBrandsBrand}>
                <div
                // href={`/brand/${decodeBase64Id(brand.id)}`}
                >
                  <Image
                    src={`${config.publicApiUrl}${brand.image}`}
                    alt="image-brand-"
                    className={styles.subCategoriesBrandsBrandImg}
                    width={45}
                    height={45}
                  />
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default MobileVersionLinks;
